import { Container, Loader, Text } from "@mantine/core";
import { useParams } from "react-router-dom";
import { useGetPage, usePatchPage } from "../../../api/pages";
import PageForm from "../PageForm";

const EditPage = () => {
  const { id } = useParams();
  const {
    data,
    isPending: isGetPending,
    isSuccess,
    isError,
    error,
  } = useGetPage(id);
  const { mutate, isPending: isPatchPending } = usePatchPage(id);

  const handleSubmit = (dirtyData, { onSuccess }) => {
    mutate(dirtyData, { onSuccess });
  };

  return (
    <Container>
      {isGetPending && <Loader />}
      {isError && <Text c="red">{error.message}</Text>}
      {isSuccess && (
        <PageForm
          initialData={data}
          onSubmit={handleSubmit}
          isSubmitting={isPatchPending}
          mode="edit"
        />
      )}
    </Container>
  );
};

export default EditPage;
